<template>
  <div class="d_flex flex_direction_col h100">
    <div class="nav_w">
      <el-tabs v-model="activeTab" type="border-card">
        <el-tab-pane label="项目介绍" name="tab1">
          <div class="">
            <!-- 招商基本信息 -->
            <div class="table-info-w fz14 c_1A1A1A d_flex flex_direction_col">
              <!-- <CardHead title="基本信息" /> -->
              <div class="title_w x_y_center c_1A1A1A font_w_bold">
                <span class="line" /><span>基本信息</span><span class="line" />
              </div>
              <table style="" cellspacing="10">
                <tr>
                  <td class="w_td font_w_bold">标的名称</td>
                  <td class="max_w_107 text_left">
                    {{ itemDetail.title }}
                  </td>
                  <td class="w_td font_w_bold">转出方式</td>
                  <td class="max_w_107 text_left">{{ transferModes.filter(n => n.key === itemDetail.transferMode)[0].value }}</td>
                </tr>
                <tr>
                  <td class="w_td font_w_bold">转出期限</td>
                  <td class="max_w_107 text_left">
                    {{ itemDetail.deadline }}{{ deadlineUnitKey[itemDetail.deadlineUnit] }}
                  </td>
                  <td class="w_td font_w_bold">转出价格</td>
                  <td class="max_w_107 text_left"><span v-if="itemDetail.priceUnit !== 'mianyi'">{{ itemDetail.price }}</span>{{ itemDetail.priceUnitDesc }}</td>
                </tr>
                <tr>
                  <td class="w_td font_w_bold">所在区域</td>
                  <td colspan="6" class="text_left">
                    {{ itemDetail.area }}
                  </td>
                </tr>
                <tr>
                  <td class="w_td font_w_bold">详细地址</td>
                  <td colspan="6" class="text_left">
                    {{ itemDetail.address }}
                  </td>
                </tr>
                <tr>
                  <td class="w_td font_w_bold">数量/面积</td>
                  <td class="max_w_107 text_left">
                    {{ itemDetail.quantity }}{{ quantityUnitKey[itemDetail.quantityUnit] }}
                  </td>
                  <td class="w_td font_w_bold">付款方式</td>
                  <td class="max_w_107 text_left">{{ paymentModeKey[itemDetail.paymentMode] }}</td>
                </tr>
                <tr>
                  <td class="w_td font_w_bold">项目介绍</td>
                  <td colspan="6" class="text_left">
                    <span ref="content" v-html="itemDetail.intro" />
                  </td>
                </tr>
              </table>
            </div>
            <!-- <CardHead title="实景图" /> -->
            <div v-if="itemDetail.images.length" class="block-space">
              <div class="title_w x_y_center c_1A1A1A font_w_bold">
                <span class="line" /><span>现场图片</span><span class="line" />
              </div>
              <div
                id="_realisticImgs"
                class="realistic_picture_w d_flex flex_wrap text_center"
              >
                <el-image
                  v-for="(item, index) in itemDetail.images"
                  :key="index"
                  class="pic_i"
                  :src="item + '!443'"
                  alt=""
                  :preview-src-list="itemDetail.images"
                />
              </div>
            </div>
            <!-- 标的视频 -->
            <div v-if="itemDetail.videos.length" id="tab3" class="block-space">
              <!-- <CardHead title="标的视频" /> -->
              <div class="title_w x_y_center c_1A1A1A font_w_bold">
                <span class="line" /><span>现场视频</span><span class="line" />
              </div>
              <div
                v-for="(item, index) in itemDetail.videos"
                :key="index"
                class="text_center video_i"
                :style="{
                  background: `url('${item.cover}') center 0 no-repeat rgb(0,0,0)`,
                }"
                @mouseenter="onTargetVideoEnter(index)"
                @mouseleave="onTargetVideoLeave"
              >
                <div
                  :id="'targetVideo_' + index"
                />
              </div>
            </div>
          </div>
          <!-- 相关附件 -->
          <div v-if="itemDetail.otherAttachments.length" id="tab4" class="block-space">
              <!-- <CardHead title="相关附件" /> -->
              <div class="title_w x_y_center c_1A1A1A font_w_bold">
                <span class="line" /><span>相关附件</span><span class="line" />
              </div>
              <div class="second_tab fz14">
                <div
                  v-for="(item, index) in itemDetail.otherAttachments"
                  :key="index"
                  class="attachs_item text_left"
                >
                  <span>附件{{ index + 1 }}：</span>
                  <span
                    class="cursor_pointer c_2CAEFF"
                    @click="
                      downLocalFile(item)
                    "
                    >{{ item.name }}
                  </span>
                  <el-progress v-if="item.downing" :percentage="item.percentage" style="white-space: nowrap;" />
                </div>
              </div>
            </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <ImportJs
      :src="`${static_resource}/js/oss.js`"
      script-key="oss"
      @loadComplete="ossCompleteFn"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import ImportJs from '@/components/base/ImportJs.vue'
import bus from '@/utils/bus'
import Player from 'xgplayer'
import { Events } from 'xgplayer'

export default {
  components: {
    ImportJs
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      initComplete: false,
      targetVideoCheck: 'pause',
      currentVideoIndex: null, // 当前hover视频索引
      player: null,
      playVideoIndex: null, // 正在播放视频索引

      activeTab: 'tab1'
    }
  },
  computed: {
    ...mapGetters([
      'siteInfo',
      'bidding',
      'paymentModeKey',
      'delayKey',
      'whether',
      'bidCountKey',
      'directionKey',
      'priceUnitKey',
      'static_resource',
      'transferModes',
      'deadlineUnitKey',
      'quantityUnitKey'
    ]),
    projectInfo() {
      return this.itemDetail
    },
    videoUrl() {
      return this.itemDetail.videos[0]?.url
    }
  },
  watch: {
    siteInfo: {
      handler(n) {
        if (Object.keys(n).length) {
          this.initBidding()
        }
      },
      immediate: true
    },
    projectInfo: {
      handler(n) {
        if (Object.keys(n).length) {
          if (!this.isSmallmicro) {
            this.getAllOtherAttachs()
          }
          this.initComplete = true
        }
      },
      immediate: true
    },
    'itemDetail.otherAttachments': {
      handler(n) {
        if (n?.length) {
          for (const v of n) {
            this.$set(v, 'downing', false)
            this.$set(v, 'percentage', 0)
          }
        }
      },
      immediate: true
    }

  },
  created() {
    this.watchPriviewOptionClick()
    this.itemDetail.otherAttachments.forEach(item => {
      item.downing = false
      item.percentage = 0
    })
    console.log('this.itemDetail.otherAttachments', this.itemDetail.otherAttachments)
  },
  mounted() {
    if (this.videoUrl) {
      this.initPlayer()
    }
  },
  destroyed() {
    window.onscroll = null
  },
  methods: {
    ...mapMutations({
      ossCompleteFn: 'app/ossCompleteFn'
    }),
    ...mapActions({
      openPreviewFile: 'upload/openPreviewFile',
      initBidding: 'cache/initBidding',
      downLocalFile: 'upload/downLocalFile'
    }),

    // 初始播放
    async initPlayer() {
      this.$nextTick(() => {
        this.player = new Player({
          id: 'targetVideo_' + 0,
          url: this.videoUrl,
          height: '427px',
          width: '100%'
        })
        // 播放完毕
        this.player.on(Events.ENDED, (e) => {
          this.$set(this, 'targetVideoCheck', '')
        })
      })
    },
    getAllOtherAttachs() {
      for (const attach of this.projectInfo?.otherAttachments) {
        this.$set(attach, 'downing', false)
        this.$set(attach, 'percentage', 0)
      }
    },
    // 关闭播放器
    onClosePlayer() {
      try {
        this.player?.destroy() // 销毁之前的播放器
        this.player = null
        this.playVideoIndex = null
      } catch (err) {
        console.log()
      }
    },
    //
    onTargetVideoEnter(index) {
      this.currentVideoIndex = index
      console.log('currentVideoIndex', this.currentVideoIndex)
    },
    //
    onTargetVideoLeave() {
      this.currentVideoIndex = null
    },
    // 预览文件 click
    onFileClick(file) {
      window.open(file.url, '_blank')
    },
    // 监听图片预览选项click事件
    watchPriviewOptionClick() {
      bus.$on('PREVIEW:OPTION', (tab) => {
        if (['tab3', 'tab5'].includes(tab)) {
          this.activeTab = 'tab1'
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.nav_w {
}
.nav-list {
  background-color: #f2f2f2;
  .nav-item {
    display: inline-block;
    width: 110px;
    height: 46px;
    line-height: 46px;
    color: #606266;
    padding: 5px 30px;
    text-align: center;
    white-space: nowrap;
  }
}
#_realisticImgs{
  margin-left: -10px;
}
::v-deep {
  .el-tabs__header {
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .el-tabs--border-card {
    box-shadow: none;
  }
  .el-tabs__item {
    height: 45px;
    line-height: 45px;
  }
  .notice-tab {
    .el-tabs__header {
      position: initial;
    }
    .el-tabs__item {
      height: 40px;
      line-height: 40px;
    }
  }
}

::v-deep .leaflet-popup-content-wrapper {
  border-radius: 4px;
  .leaflet-popup-content {
    margin: 10px;
  }
}
::v-deep .leaflet-popup-tip {
  width: 12px;
  height: 12px;
}

.tab_nav_w {
  margin: 0 0 50px 0;
  padding-bottom: 50px;
}

::v-deep .tab_w {
  // width: 876px;
  padding: 0 20px;
  margin: 30px 0;

}
.title_w {
    margin-bottom: 30px;
    font-size: 24px;
    & span {
      &:nth-child(2) {
        margin: 0 10px;
      }
    }
    .line {
      display: inline-block;
      width: 42px;
      height: 2px;
      background: #0983cc;
    }
  }

.tab_c_w {
  min-height: 700px;
  padding: 0;
}

::v-deep .table-info-w{
  & > table {
    // width: 876px;
    // border-color: #e6e6e6;

    //标准单元格宽度
    .w_td {
      width: 85px;
      text-align: center;
    }
    //最大单元格宽度164
    .max_w_164 {
      max-width: 164px;
    }
    //最大单元格宽度210
    .max_w_210 {
      max-width: 210px;
    }
    //最大单元格宽度270
    .max_w_107 {
      width: 358px;
    }
    //最大单元格宽度696
    .max_w_696 {
      max-width: 696px;
    }

    &:last-of-type {
      border-bottom: 1px solid #e6e6e6;
      // tr{
      //   &:last-child{
      //     td{
      //       border-bottom: 1px solid #e6e6e6;
      //     }
      //   }
      // }
    }
    tr {
      &:first-child {
        td {
          &:first-child {
            border-left: 1px solid #e6e6e6;
          }
        }
      }
      td {
        word-break: break-word;
        box-sizing: border-box;
        padding: 10px;
        border-top: 1px solid #e6e6e6;
        border-right: 1px solid #e6e6e6;
      }
    }
    .table_title {
      padding: 0 18px;
      box-sizing: border-box;
      width: 82px;
      line-height: 34px;
      font-size: 18px;
      background: #eaf2fa;
    }
  }
}
.location_w {
  margin: 50px 0 20px 0;
}

.tab_content_w {
  padding: 0 0 20px 0;
}
.second_tab {
  .attachs_item {
    margin-bottom: 5px;
  }
}
.block-space {
  margin: 20px 0;
}
.video_i {
  position: relative;
  margin-bottom: 10px;
  &:last-child {
    margin: 0 auto;
  }
  .video_i_play_btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    z-index: 1;
  }
}

.realistic_picture_w {
  .pic_i {
    flex-basis: 50%;
    margin: 0 0 10px 0;
    padding-left: 10px;
    box-sizing: border-box;
    max-height: 250px;
  }
}

.biddings_w {
  color: #1a1a1a;
  .state_text {
    width: 42px;
    height: 21px;
    padding: 0 3px;
    color: #1a1a1a;
    border: 1px solid #b3b3b3;
  }

  &:nth-child(1) {
    .state_text {
      padding: 2px 5px;
      border: 0;
      color: #fff;
      background-color: #cf3342;
    }
  }

  &:last-child {
    .cell_item {
      border-bottom: 0;
    }
  }
}

.cell_item {
  padding: 14px 0;
  border-bottom: 1px solid #e6e6e6;
}

table {
  border-collapse: collapse; /* 确保边框相邻 */
}
td, th {
  border: 1px solid #DDDFE6; /* 设置边框为1并设置边框颜色为黑色 */
}
.contains-image {
  max-width: 200px;
  display: block;
}

</style>
